import { Card } from "primereact/card";
import { ProgressBar } from "primereact/progressbar";
import { Chart } from "primereact/chart";
import { toMinuteValue } from "../../../../../utils/constants";
import { useSelector } from "react-redux";
import { ProgressSpinner } from "primereact/progressspinner";
const pieOptions = {
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false },
    datalabels: { display: false },
  },
};

const Credits = ({ xmotFormData, handleXmotFormChange, loading }) => {
  const { usedCredits = 0 } = useSelector(
    (state) => state.selectedSurveyCategory,
  );
  const {
    seletedCustomRecruit,
    expectedSessionDuration,
    timeline,
    participants,
  } = xmotFormData;
  const {
    xmot_credits = 0,
    used_credits = 0,
    recruit_value: totalParticipants = 0,
  } = seletedCustomRecruit || {};
  const { participantsValues = [] } = participants;
  const { stopXmotBasedOn, stopXmotValue } = timeline || {};
  const balancedCredits = Math.max(0, xmot_credits - used_credits);
  const expectedDur = toMinuteValue(expectedSessionDuration);
  const estimatedUsedCredits =
    stopXmotBasedOn === 1
      ? stopXmotValue
      : stopXmotBasedOn === 2
        ? stopXmotValue * expectedDur * participantsValues?.length
        : expectedDur * participantsValues?.length;
  const getPercentageUsage = (usedCredits, balancedCredits) => {
    if (!balancedCredits) return 0;
    return (usedCredits / balancedCredits) * 100;
  };
  const pieData = {
    labels: ["Used", "Remaining"],
    datasets: [
      {
        data: [estimatedUsedCredits, balancedCredits - estimatedUsedCredits],
        backgroundColor: ["#ff9800", "#E0E0E0"],
        hoverBackgroundColor: ["#ff9800", "#BDBDBD"],
        cutout: "75%",
      },
    ],
  };

  return (
    <div className="mt-4 text-start">
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="4"
            animationDuration="0.5s"
          />
        </div>
      )}
      <p className="heading text_dark fw-600 fs-18">Credits</p>

      <div className="p-4">
        <div className="row">
          {/* Left Card: Credit Overview */}
          <div className="col-md-6 flex-fill">
            <Card className="p-4 shadow-sm credit-card h-100">
              <h5 className="fw-600 text_dark text-center mb-4">
                Credit Overview
              </h5>

              <div className="circle-wrapper mx-auto" style={{ width: 180 }}>
                <Chart type="doughnut" data={pieData} options={pieOptions} />
                <div className="center-label">
                  <span className="credit-value">{estimatedUsedCredits}</span>
                  <span className="credit-label">Estimated Credits</span>
                </div>
              </div>

              <div className="text-center mt-4">
                <p className="mb-1">
                  <strong>Total Credits:</strong>{" "}
                  <span className="text_dark fw-600">{balancedCredits}</span>
                </p>
                <p className="mb-0">
                  <strong>Balance Credits:</strong>{" "}
                  <span className="text-success fw-600">
                    {balancedCredits - estimatedUsedCredits}
                  </span>
                </p>
              </div>
            </Card>
          </div>

          {/* Right Card: Details */}
          <div className="col-md-6 flex-fill">
            <Card className="p-4 shadow-sm details-card h-100">
              <h5 className="fw-600 mb-4">Details</h5>

              <div className="h-100">
                <div>
                  <div className="d-flex justify-content-between mb-3">
                    <div className="d-flex align-items-center">
                      <i className="pi pi-users me-2" />
                      <span className="fs-14">
                        Total Participants Targeted:
                      </span>
                    </div>
                    <strong>{participantsValues?.length}</strong>
                  </div>

                  <div className="d-flex justify-content-between mb-3">
                    <div className="d-flex align-items-center">
                      <i className="pi pi-stopwatch me-2" />
                      <span className="fs-14">XMOT Duration:</span>
                    </div>
                    <strong>{expectedDur} min</strong>
                  </div>

                  <div className="d-flex justify-content-between mb-4">
                    <div className="d-flex align-items-center">
                      <i className="pi pi-credit-card me-2" />
                      <span className="fs-14">Estimated Credits:</span>
                    </div>
                    <strong>{estimatedUsedCredits}</strong>
                  </div>
                </div>

                <div
                  className="me-auto d-flex align-items-end"
                  style={{
                    minHeight: "120px",
                  }}
                >
                  <div className="credit-usage w-100">
                    <p className="fw-semibold mb-1 fs-14">Credits Usage</p>
                    <ProgressBar
                      value={getPercentageUsage(
                        usedCredits,
                        balancedCredits,
                      ).toFixed(2)}
                      showValue={false}
                      color="#ff9800"
                      style={{ height: "12px", borderRadius: "10px" }}
                    ></ProgressBar>
                    <small className="mt-1">
                      {getPercentageUsage(usedCredits, balancedCredits).toFixed(
                        2,
                      )}
                      % Used
                    </small>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Credits;
